<template>
	<div class="hello">
		<div class="header">
			<van-nav-bar title="" left-text="返回" @click-left="backJump" left-arrow>
			  <template #right>
				  <van-icon name="ellipsis" />
			  </template>
			</van-nav-bar>
			<img src="../assets/topback.png" style="width: 190px;height: 146px;float: right;" alt="">
			<div>
				<h2><span>用</span>量记录</h2>
			</div>
		
		</div>
		<div class="content" style="position: relative;">
			<div class="center">
				<div class="center_al">
					<div class="bt">
						<img src="../assets/dian.png" >
						<span>电费</span>
					</div>
					<div class="cont_top">
						<div>
							<span class="left">识别编码信息</span><span class="right">{{account}}</span>
						</div>
						<div>
							<span class="left">住址信息</span><span class="right">{{address}}</span>
						</div>
						<div>
							<span class="left">缴费单位</span><span class="right">{{payer}}</span>
						</div>
					</div>
				</div>
				
			</div>
			<div class="cont_center">
				<div class="center_con">
					<p>使用明细（千瓦时）</p>
					<div class="btnal">
						<div :style="month" @click="echange(0)">
							<span>月用电费</span>
						</div>
						<div :style="day" @click="echange(1)">
							<span>日用电费</span>
						</div>
					</div>
					<div style="height: 200px;"></div>
					<div :style="tian">
						<ul class="day" >
							<li style="color: #8E8E8E;height: 27px;text-align: center;font-size: 13px;" class="zty">
								<div>
									<span>时间</span>
								</div>
								<div>
									<span>峰电（千瓦时）</span>
								</div>
								<div>
									<span>谷电（千瓦时）</span>
								</div>
							</li>
							<li v-for="item in dayfa" class="siz" style="height: 27px;;margin-top:20px;text-align: center;border-bottom: 1px solid #DEE1E5;">
								<div>
									<span style="color: #8E8E8E;">{{item.date}}</span>
								</div>
								<div>
									<span>{{item.feng}}</span>
								</div>
								<div>
									<span>{{item.gu}}</span>
								</div>
							</li>
							<li style="height: 27px;;margin-top:20px;text-align: center;">
								<div style="float: left;width: 50%;text-align: center;line-height: 27px;">
									<span>合计</span>
								</div>
								<div style="float: left;width: 50%;line-height: 27px;">
									<span>{{total}}</span>
								</div>
							</li>
						</ul>
					</div>
					<div :style="yue">
						<ul class="date">
							<li style="color: #8E8E8E;height: 27px;text-align: center;font-size: 12px;" class="zty">
								<div>
									<span>时间</span>
								</div>
								<div>
									<span>峰电（千瓦时）</span>
								</div>
								<div>
									<span>谷电（千瓦时）</span>
								</div>
							</li>
							<li v-for="item in date" class="siz" style="height: 27px;;margin-top:20px;text-align: center;border-bottom: 1px solid #DEE1E5;">
								<div>
									<span style="color: #8E8E8E;">{{item.date}}</span>
								</div>
								<div>
									<span>{{item.feng}}</span>
								</div>
								<div>
									<span>{{item.gu}}</span>
								</div>
							</li>
							<li style="height: 27px;;margin-top:20px;text-align: center;">
								<div style="float: left;width: 50%;text-align: center;line-height: 27px;">
									<span>合计</span>
								</div>
								<div style="float: left;width: 50%;line-height: 27px;">
									<span>{{total}}</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	import jump from "../common/jump";

  export default{
		data(){
			return{
				yue:{
					 marginBottom: '20px',
					display:'none'
				},
				tian:{
					 marginBottom: '20px',
					display:'block'
				},
				
				title:'当前余额',
				shz:'',
				total:'',
				month:{
					color:'#95c4fb',
					width:'80px',
					height:'30px',
					backgroundColor:'#4e9df9',
					borderRadius:'50px',
					marginTop:'5px',
					marginLeft:'14px',
					textAlign:'center',
					lineHeight:'30px'
				},
				day:{
					color:'#0f72dd',
					width:'80px',
					height:'30px',
					backgroundColor:'#fff',
					borderRadius:'50px',
					marginTop:'5px',
					marginLeft:'14px',
					textAlign:'center',
					lineHeight:'30px'
				},
				account:'',
				address:'',
				payer:'',
				dayfa:[
					{
						date:'2021-11-29',
						feng:5.1,
						gu:8.0
					},
					{
						date:'2021-11-28',
						feng:4.1,
						gu:8.0
					},
					{
						date:'2021-11-27',
						feng:8.1,
						gu:8.0
					}
				],
				date:[
					{
						date:'2021-11',
						feng:5.1,
						gu:8.0
					},
					{
						date:'2021-11',
						feng:4.1,
						gu:8.0
					},
					{
						date:'2021-11',
						feng:8.1,
						gu:8.0
					}
				]
			}
		},
		mounted() {},
		methods:{
      backJump(){
        this.$destroy()
        jump.$emit('back')
        this.$router.go(-1)
      },
			echange:function(zhi){
				if(zhi == "0"){
					this.month.backgroundColor = '#fff'
					this.month.color = '#0f72dd'
					this.day.backgroundColor = '#4e9df9'
					this.day.color = '#95c4fb'
					this.yue.display = 'block'
					this.tian.display = 'none'
					this.total = '30'
				}
				else if(zhi == "1"){
					this.day.backgroundColor = '#fff'
					this.day.color = '#0f72dd'
					this.month.backgroundColor = '#4e9df9'
					this.month.color = '#95c4fb'
					this.yue.display = 'none'
					this.tian.display = 'block'
					this.total = '17.1'
				}
			}
		}
	}
</script>

<style scoped>
	.siz div{
		float: left;width: 33%;line-height: 27px;
	}
	.zty div{
		float: left;width: 33%;background-color: #EFF1F0 ;line-height: 27px;
	}
	.header{
		width: 100%;
		height: 192px;
		background-color: #295ad0;
	}
	
	.header h2{
		letter-spacing:2px;
		color: rgb(255, 255, 255);
		line-height: 120px;
		position: relative;
		margin-left:20px
	}
	.header h2 span{
		border-bottom: 3px solid #fff;
	}
	.center{
		width: 90%;
		height: 400px;
		margin: 0 auto;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		border-radius: 10px;
		margin-top:-20px;
		background-color: #fff;
	}
	.center_al{
		width: 80%;
		margin: 0 auto;
	}
	.bt{
		margin-top:20px
	}
	.bt img{
		width: 38px;
		height:38px;
		float: left;
	}
	.bt span{
		line-height: 42px;
		margin-left: 10px;
		font-size: 20px;
	}
	.bt p{
		color:#0f72dd
	}
	.cont_top{
		
		margin-top:20px
	}
	.cont_top div{
		height: 30px;
		margin-top: 35px;
		border-bottom: 1px solid #dee1e5;
	}
	.cont_top div .left{
		color:#8e8e8e;
		float: left;
	}
	.cont_top div .right{
		color:#000;
		float: right;
	}
	.cont_center{
		width: 90%;
		margin: 0 auto;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		border-radius: 10px;
		margin-top:20px;
		
	}
	.center_con{
		width:80%;
		margin: 0 auto;
		padding-top: 10px;
		margin-bottom: 20px;
	}
	.center_con p{
		color:#0f72dd;
	}
	.btnal{
		width:200px;
		background-color: #4e9df9;
		height:40px;
		border-radius: 50px;
		margin: 0 auto;
	}
	.btnal div{
		float: left;
	}
</style>
